import { Eyebrow, MaskLines, Reveal } from "./Motion";

export const SectionHeading = ({ eyebrow, lines, label, children, className = "", size = "lg" }) => {
  const sizes = {
    lg: "text-[clamp(2.9rem,7vw,6.5rem)]",
    xl: "text-[clamp(3.2rem,9vw,8.5rem)]",
  };
  return (
    <div className={className}>
      <Reveal><Eyebrow>{eyebrow}</Eyebrow></Reveal>
      <MaskLines
        lines={lines}
        label={label}
        className={`mt-6 font-display uppercase leading-[0.88] text-pa-ink ${sizes[size]}`}
      />
      {children && (
        <Reveal delay={0.2} className="mt-8 max-w-xl text-base leading-relaxed text-pa-muted md:text-lg">
          {children}
        </Reveal>
      )}
    </div>
  );
};
